export default __webpack_public_path__ + "static/media/1 - Вендинговые аппараты.77cfc8ee.jpg";